import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Image } from '../interfaces/image';
import { BaseService } from './base.service.class';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ImageService extends BaseService {
  private _endpointUrl: string;

  constructor(
    private http: HttpClient,
    protected notificationService: NotificationService
  ) {
    super(notificationService);
    this._endpointUrl = '';
  }

  public set endpointUrl(value: string) {
    this._endpointUrl = value;
  }

  createImage(formData: FormData): Observable<Image[] | HttpEvent<Image[]>> {
    return this.http
      .post<Image[]>(this._endpointUrl, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        tap((_) => console.log('image created')),
        catchError(this.handleError<Image[]>('createImage'))
      );
  }

  updateImage(imageToUpdate: Image): Observable<Image[]> {
    return this.http.put<Image[]>(this._endpointUrl, [imageToUpdate]).pipe(
      tap((_) => console.log('image updated')),
      catchError(this.handleError<Image[]>('updateImage'))
    );
  }

  deleteImage(imageToDelete: Image): Observable<boolean> {
    return this.http
      .delete<boolean>(`${this._endpointUrl}?imageId=${imageToDelete.imageId}`)
      .pipe(
        tap((_) => console.log('image deleted')),
        catchError(this.handleError<boolean>('deleteImage'))
      );
  }
}
